import React from 'react'
import Svg, { G, Path, SvgProps } from 'react-native-svg'

import { Color } from '../../style'

export interface Props extends SvgProps {}
const IconFinance = (props: Props) => {
  const { width, height, color, ...otherProps } = props
  return (
    <Svg
      width={width}
      height={height}
      viewBox={`0 0 ${IconFinance.dimensions.width} ${IconFinance.dimensions.height}`}
      {...otherProps}
    >
      <G fill={color || Color.premiumBlack} fillRule="nonzero">
        <Path d="M3.047 14.14l.174.008a1.986 1.986 0 011.813 1.979v6.4a1.986 1.986 0 01-1.987 1.987h-1.06A1.986 1.986 0 010 22.527v-6.4a1.986 1.986 0 011.987-1.987h1.06zm0 1.134h-1.06a.852.852 0 00-.853.853v6.4a.852.852 0 00.853.853h1.06a.852.852 0 00.853-.853v-6.4a.852.852 0 00-.853-.853z" />
        <Path d="M4.587 16.644h1.07c.367-.001.717-.15.97-.415l2.566-2.636a.14.14 0 01.112-.05l5.832.25.212.01c.406.02.724.355.721.76a.763.763 0 01-.659.762l-3.899.52a.567.567 0 10.15 1.124l3.9-.52a1.895 1.895 0 001.642-1.884 1.888 1.888 0 00-1.8-1.894L11.6 12.5c-.789-.033-1.568-.064-2.242-.09a1.262 1.262 0 00-.986.398l-2.562 2.632a.215.215 0 01-.156.069H4.587a.567.567 0 100 1.134z" />
        <Path d="M16.673 15.443l1.73-.11a4.412 4.412 0 001.825-.528l4.08-2.22a.7.7 0 01.862.155.69.69 0 01-.113 1.003l-6.118 4.539c-.43.315-.908.565-1.416.739L9.786 21.63a5.287 5.287 0 01-1.588.27l-3.727.04a.567.567 0 00.012 1.134l3.73-.04c.66-.01 1.31-.121 1.933-.33l7.742-2.61a6.451 6.451 0 001.724-.9l6.123-4.542a1.827 1.827 0 00.292-2.655 1.836 1.836 0 00-2.26-.408l-4.081 2.22c-.418.228-.88.361-1.356.392l-1.729.11a.567.567 0 00.072 1.132zM14.785 6.027l.092.007a.553.553 0 11-.546.643l-.007-.09a.567.567 0 10-1.134 0A1.687 1.687 0 1014.877 4.9a.567.567 0 00-.092 1.127z" />
        <Path d="M14.969 4.907l-.092-.007a.553.553 0 11.546-.643l.007.09a.567.567 0 101.134 0 1.687 1.687 0 10-1.687 1.687.567.567 0 00.092-1.127z" />
        <Path d="M15.444 3.067v-.48a.567.567 0 10-1.134 0v.48a.567.567 0 101.134 0zM15.444 8.337v-.48a.567.567 0 10-1.134 0v.48a.567.567 0 101.134 0z" />
        <Path d="M14.997 0a5.697 5.697 0 110 11.394 5.697 5.697 0 010-11.394zm0 1.134a4.563 4.563 0 100 9.126 4.563 4.563 0 000-9.126z" />
      </G>
    </Svg>
  )
}

IconFinance.dimensions = {
  width: 27,
  height: 25,
}

export default IconFinance
